import React, { useEffect, useState } from 'react'
import ButtonStartIcon from '../../../../button/ButtonStartIcon'
import Typography from '@mui/material/Typography'
import InputField from '../../../../FormControl/input/InputField'
import Dialog from '../../../../dialog/Dialog'
import useCurriculum from '../../../../../hooks/curriculum/useCurriculum'
import { Alert } from '@mui/material'

const DialogCurriculum = ({ 
  show, onClose,
  type, data
}) => {
  const types = ['create', 'delete']
  const { 
    errors: errorsData,
    createCurriculum,
    deleteCurriculum
  } = useCurriculum()
  const [form, setInputForm] = useState({})
  const [errors, setInputErrors] = useState(errorsData)
  const [loading, toggleLoading] = useState(false)

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value })
    setInputErrors({ ...errors, [name]: null })
  }

  const onSave = async (e) => {
    if (!['create', 'delete'].includes(type))  {
      setInputErrors({ message: 'Invalid type' })
      return
    }
    e.preventDefault()
    toggleLoading(true)
    try {
      let result = { error: false }
      if (type === 'create') {
        result = await createCurriculum(form)
      }

      if (type === 'delete') {
        result = await deleteCurriculum(form._id)
      }

      if (result.error) {
        setInputErrors(result)
      } else {
        onClose()
      }
    } finally {
      toggleLoading(false)
    }
  }

  useEffect(() => {
    setInputErrors(errorsData)
  }, [errorsData])

  useEffect(() => {
    setInputForm(data || {})
  }, [data])
  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      { types.includes(type) &&
        <ButtonStartIcon
        onClick={onSave}
        color='primary'
        variant='contained'
        disabled={loading}
        loading={loading}
        startIcon={["fal","check"]}
      >
        { type === 'delete' ? 'Confirm' : 'Save'}
      </ButtonStartIcon>
      }
    </>
  );

  return (
    <Dialog
      id={`${type}-curriculum-dialog`}
      show={show} 
      title={`${type} curriculum`}
      onClose={onClose}
      actions={Actions}
    >
      { type === 'delete'
        ? <Typography>Are you sure you want to delete the curriculum: <b>{form.name}</b>?</Typography>
        : <div className='flex flex-col gap-4 py-4'>
          <div className='grid grid-cols-4 items-start gap-4'>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Name
            </Typography>
            <div className='col-span-3'>
              { type === 'preview'
                ? <Typography>
                    {form.name}
                  </Typography>
                :  <InputField
                  id='name'
                  name='name'
                  value={form.name}
                  error={errors?.name}
                  helperText={errors?.name}
                  onChange={(e) => onChange("name", e.target.value)}
                  fullWidth
                  multiline={true}
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Short Name
            </Typography>
            <div className='col-span-3'>
              { type === 'preview'
                ? <Typography>
                    {form.shortName}
                  </Typography>
                :  <InputField
                  id='shortName'
                  name='shortName'
                  value={form.shortName}
                  error={errors?.shortName}
                  helperText={errors?.shortName}
                  onChange={(e) => onChange("shortName", e.target.value)}
                  fullWidth
                />
              }
            </div>
          </div>
        </div>
      }
      { errors && errors.message && 
        <Alert 
          severity="error"
          onClose={() => setInputErrors({ message: null })}
        >
          {errors.message}
        </Alert> 
      }
    </Dialog>
  )
}

export default DialogCurriculum